import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { Observable } from 'rxjs';
import { UploadMediaService } from '../upload-media/upload-media.service';
import { MediaService } from '../../providers';
import { Media, MediaType, Video } from '../../models';

@Component({
    selector: 'external-video-manager',
    templateUrl: './external-video-manager.component.html',
    styleUrls: ['./external-video-manager.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class ExternalVideoManagerComponent implements OnInit {

    @Input() media: Media = null;
    @Input() isInactive: boolean = false;
    @Input() openExternalVideoPopup: Observable<void>;
    @Output() externalVideoChange = new EventEmitter<Media>();
    @Output() moteChanged = new EventEmitter<boolean>();

    public showExternalVideoPopup: boolean = false;
    public showFilmcentralenHelp: boolean = false;
    public externalVideo: Video = {
        url: "",
        type: MediaType.YOUTUBE_VIDEO
    }

    // Expose to view
    public MediaType = MediaType;

    constructor(
        private mediaService: MediaService,
        private uploadMediaService: UploadMediaService) { }

    ngOnInit(): void {
        this.openExternalVideoPopup.subscribe(() => this.showExternalVideoPopup = true);
    }

    public async saveExternalVideo() {

        if(!this.media) return console.warn("No media selected, can't add external video");

        // Check that video url is valid
        if(!ExternalVideoManagerComponent.isExternalVideoValid(this.externalVideo.url, this.externalVideo.type)) return;

        // Check that user is ok with overwriting video if it exists
        if(this.media.type == MediaType.VIDEO && this.media.video.url) {
            let ok = confirm("This will overwrite and delete the existing video. Is that okay with you?");
            if(!ok) return;
            // Remove old video
            console.log("Removing old video from cloud");
            await this.mediaService.deleteFiles([this.media.video]);
        }

        this.showExternalVideoPopup = false;
        // Save external video in active media element media 
        this.media.type = this.externalVideo.type;
        this.media.video.mediaType = this.externalVideo.type;
        this.media.video.url = this.externalVideo.url;
        this.externalVideoChange.emit()
    }

    public static isExternalVideoValid(url: string, type: MediaType): boolean {
        if(type == MediaType.FILMCENTRALEN_VIDEO) {
            return url.startsWith("https://filmcentralen.dk/embed");
        }
        else {
            return url.startsWith("https://www.youtube.com") || url.startsWith("https://youtube.com");
        }
    }

    public transformExternalVideoUrl(url: string) {
        this.externalVideo.url = url;

        if(!url) return;
        // Return filmcentralen url (don't transform it)
        if(this.externalVideo.type == MediaType.FILMCENTRALEN_VIDEO) return;
        // Just return url if it was already transformed to a embed link
        if(url.startsWith("https://www.youtube.com/embed")) return;
        // Transform std. youtube url
        this.externalVideo.url = url.replace("https://www.youtube.com/watch?v=", "https://www.youtube.com/embed/");
    }

    public validateExternalVideo(url, ev: { url: string, type: MediaType }): string {
        if(!ev || !url) return "";

        let startWith = (ev.type == MediaType.FILMCENTRALEN_VIDEO) ? "https://filmcentralen.dk/embed" : "https://youtube.com/";
        return ExternalVideoManagerComponent.isExternalVideoValid(ev.url, ev.type) ? "" : `The link should look like this: ${startWith}..`;
    }

    public async removeExternalVideo() {
        if(!this.media) return console.warn("No media selected, can't add external video");
        let ok = confirm("Delete external video url, is that okay with you?");
        if(!ok) return;
        this.moteChanged.emit(true);
        this.media.video.url = "";
        // Update media type and select correct active file
        this.uploadMediaService.sendUpdateMediaTypeEvent(this.media);
    }

    public addExternalVideo() {
        if(!this.media) return console.warn("No media selected, can't add external video");
        this.showExternalVideoPopup = true;
        let isExternalVideo = (this.media.type == MediaType.FILMCENTRALEN_VIDEO || this.media.type == MediaType.YOUTUBE_VIDEO);

        // Set tmp external video values from selected media 
        this.externalVideo.url = (isExternalVideo) ? this.media.video.url : "";
        this.externalVideo.type = (this.media.type == MediaType.FILMCENTRALEN_VIDEO) ? MediaType.FILMCENTRALEN_VIDEO : MediaType.YOUTUBE_VIDEO;
        this.moteChanged.emit(true);
    }
}
